<template>
  <div>
    <van-cell-group :title="formInfo.Name">
      <div class="form">
        <Parser v-if="formKey && formConf" :formConf="formConf" @submit="submit"></Parser>
      </div>
    </van-cell-group>
  </div>
</template>

<script>
import Parser from '@/components/formGenerator/components/parser/Parser'
import {Toast} from "vant";

export default {
  name: "add",
  components: {Parser},
  data() {
    return {
      formKey: this.$route.params.formKey,
      formInfo: {},
      formConf: {},
    }
  },
  mounted() {
    this.getForm()
  },
  methods: {
    getForm() {
      let self = this;
      this.whale.remote.getResult({
        url: "/api/api/flow-form/detail?key=" + self.$route.params.formKey,
        completed: function ({ResultType, Message, AppendData}) {
          if (ResultType == 0) {
            self.formInfo = AppendData
            self.formConf = JSON.parse(AppendData.EditorTxt)
            console.log(11111,self.formConf)
          } else {
            Toast.fail(Message)
          }
        }
      })
    },
    submit(val) {
      let datas = JSON.stringify(val)
      let self = this
      this.whale.remote.getResult({
        url: "/api/api/flow-form-data/add",
        data: {
          formKey: self.formKey,
          datas,
        },
        completed: function ({ResultType, Message}) {
          if (ResultType == 0) {
            self.$router.go(-1)
          } else {
            Toast.fail(Message);
          }
        }
      })
    },
  }
}
</script>

<style scoped>
.form{
  background: #fff;
  padding: 15px;
}
</style>